import * as React from "react"

const IamJobsIconMenu: React.FC = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="Layer_1"
        viewBox="0 0 32 32"
        enableBackground="new 0 0 70 70"
        width="32"
        height="32"
    >
        <linearGradient
            id="SVGID_1_"
            x1={16}
            x2={16}
            y1={34}
            y2={2}
            gradientTransform="matrix(1 0 0 -1 0 34)"
            gradientUnits="userSpaceOnUse"
        >
            <stop
                offset={0}
                style={{
                    stopColor: "#0062ff",
                }}
            />
            <stop
                offset={1}
                style={{
                    stopColor: "#004bc2",
                }}
            />
        </linearGradient>
        <path
            d="M6.6 0h18.7C29 0 32 3 32 6.6v18.7c0 3.7-3 6.6-6.6 6.6H6.6C3 32 0 29 0 25.4V6.6C0 3 3 0 6.6 0z"
            style={{
                fill: "url(#SVGID_1_)",
                fillOpacity: 0.1,
            }}
        />
        <path
            d="M25.3 21.6s-.3-1.2-.8-2.5c-.8-1.9-1.7-3.1-2.9-3.7-.2-.1-1.9-.9-1.9-.9l-.8-.7-1 1-.6.1-1.1-1.1-.8.7-1.4.7-7 .5c-.1 0-.2.1-.3.2-.1.1-.1.2 0 .4.6 1 1 1.9 1.4 2.7l-.1.1c-1.3 1.3-1.2 2.6-.8 3.3.3.5.8.7 1.3.7.3 0 .6-.1.8-.2.1 0 .1-.1.2-.1.1.4.2.8.2 1.2.3 1.7.1 2.5 0 2.5 0 .1 0 .2.1.3.1.1.2.1.3.1l11-.4c.2 0 .4-.2.4-.4v-.8h.2c.4 0 .7-.1 1-.4l2-1.8c.5-.4.7-.9.6-1.5zm-14.7 4.6c.1-.6.1-1.9-.4-3.9.6-.5.8-1.2.7-1.8h.5c.2 0 .3-.1.3-.2.1-.1.1-.2 0-.4l-1.1-2.8c0-.1-.1-.1-.2-.1h-.2c-.1 0-.1.1-.1.1l1 2.5v.2c-.1.2-.1.2-.2.2h-.2v-.1c-.3-.6-1.1-.5-1.5-.5-.4-.9-.9-2-1.5-3.1l10.6-.9c.4.9 1.7 4.1 2.2 7.4-.2.5-.2 1.3.2 1.8v1l-10.1.6zm10.6-4 .3-2.2.6 1.5-.9.7zM17.6 13.8c2.1 0 3.6-1.9 3.6-5.1 0-2.2-1-3.6-3.6-3.6S14 6.4 14 8.7c0 3.1 1.5 5.1 3.6 5.1z"
            fill="#052351"
        />
        <path
            d="m12.3 22.6 5.3-.3c.3 0 .5-.3.5-.6s-.3-.5-.6-.5l-5.3.3c-.3 0-.5.3-.5.6s.3.5.6.5zM17.9 23.4l-5.3.3c-.3 0-.5.3-.5.6s.3.5.6.5l5.3-.3c.3 0 .5-.3.5-.6-.1-.3-.3-.5-.6-.5zM12.6 20.1c.2.1.4.2.7.2.2 0 .4-.1.5-.3.1-.2.1-.3 0-.5l-.8-1.9c-.1-.2-.2-.4-.4-.5-.2-.1-.4-.2-.7-.2-.2 0-.4.1-.5.3-.1.2-.1.3 0 .5l.8 1.9c0 .2.2.4.4.5zm-.7-2.6c0-.1.1-.1.2-.1s.2 0 .2.1c.1 0 .1.1.1.2l.8 1.9v.2c0 .1-.1.1-.2.1s-.2 0-.2-.1c-.1 0-.1-.1-.1-.2l-.8-1.9v-.2zM14.5 20.1c0 .1.1.1.2.1l1-.1c.2 0 .3-.1.3-.2.1-.1.1-.2 0-.4l-.4-1-.1-.1h-.2c.1 0 .1 0 .1-.1v-.1l-.4-1-.3-.3c-.1-.1-.3-.1-.4-.1l-1 .1c-.1 0-.1.1-.1.1l1.3 3.1zm.6-1.4c.1 0 .1.1.1.1l.2.6v.1l-.1.1h-.4l-.4-1h.4c.1.1.1.1.2.1zm-.7-1.5h.2c.1 0 .1.1.1.1l.2.6v.1l-.1.1h-.4l-.4-1 .4.1zM15.8 17.8c.1.2.2.3.4.5.2.1.5.2.7.2.1 0 .2 0 .2.1.1 0 .1.1.1.2l.2.5v.2c0 .1-.1.1-.2.1s-.2 0-.2-.1c-.1 0-.1-.1-.1-.2v-.1c0-.1-.1-.1-.2-.1h-.2c-.1 0-.1.1-.1.1v.1c.1.2.2.4.4.5.2.1.4.2.7.2.2 0 .4-.1.5-.3.1-.2.1-.3 0-.5l-.2-.5c-.1-.2-.2-.3-.4-.5-.1-.1-.4-.2-.6-.2-.1 0-.2 0-.2-.1-.1 0-.1-.1-.2-.2l-.2-.5V17c0-.1.1-.1.2-.1s.2 0 .2.1c.1 0 .1.1.1.2v.1c0 .1.1.1.2.1h.2c.1 0 .1-.1.1-.1v-.1c-.1-.2-.2-.4-.4-.5-.2-.1-.4-.2-.7-.2-.2 0-.4.1-.5.3-.1.2-.1.3 0 .5l.2.5z"
            fill="#052351"
        />
    </svg>
)
export default IamJobsIconMenu
